import { createAction } from "@reduxjs/toolkit";

import { RequestNotificationsTypes } from "src/containers/requests/constants/requests-notifications";
import { AppActionTypes } from "src/redux/ui/action-types";

export interface Loading {
    type: AppActionTypes.UI_LOADING;
    payload: {
        isLoading: boolean;
        afterDispatch?: VoidFunction;
    };
}

export interface RequestNotification {
    type: AppActionTypes.TOGGLE_REQUESTS_NOTIFICATIONS_STATUS;
    payload: {
        requestType: RequestNotificationsTypes;
    };
}

export const toggleMenuOptions = createAction(
    AppActionTypes.MENU_TOGGLE_OPTIONS
);

export const showPaymentsInMenu = createAction(
    AppActionTypes.SHOW_PAYMENTS_IN_MENU
);

export const toggleChatDelayModal = createAction(
    AppActionTypes.TOGGLE_CHAT_DELAY_MODAL
);

export const toggleVeraWhatsappModal = createAction(
    AppActionTypes.TOGGLE_VERA_WHATSAPP_MODAL
);

export const toggleChatInMaintenanceModal = createAction(
    AppActionTypes.TOGGLE_CHAT_IN_MAINTENANCE_MODAL
);

export const toggleOopsModal = createAction(AppActionTypes.TOGGLE_OOPS_MODAL);

export const toggleNotificationsConfigModal = createAction(
    AppActionTypes.ToggleNotificationsModal
);

export const toggleDownloadAppModal = createAction(
    AppActionTypes.ToggleDownloadAppModal
);

export const toggleRequestsNotificationsStatus = createAction(
    AppActionTypes.TOGGLE_REQUESTS_NOTIFICATIONS_STATUS,
    (requestType: string) => ({
        payload: {
            requestType,
        },
    })
);

export const uiLoading = createAction(
    AppActionTypes.UI_LOADING,
    (isLoading: boolean, cb?: VoidFunction) => ({
        payload: {
            isLoading,
            afterDispatch: cb,
        },
    })
);
